<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="stylus">
html
  font-size 62.5%
</style>



// WEBPACK FOOTER //
// App.vue?8fb58ea6